export const siteConfig = {
  brandName: 'JTech Web Studio',
  ownerName: 'Anmoldeep Singh Johal',
  tagline: 'Helping startups and small businesses build a strong, trustworthy online presence.',
  whatsappPhone:
    process.env.REACT_APP_WHATSAPP_PHONE?.replace(/\D/g, '') || '',
  defaultWhatsAppMessage:
    "Hi! I'm interested in a website for my business. Can we talk about options and pricing?",
};

export function getWhatsAppUrl(message = siteConfig.defaultWhatsAppMessage) {
  const phone = siteConfig.whatsappPhone.replace(/\D/g, '');
  const text = encodeURIComponent(message);
  return `https://wa.me/${phone}?text=${text}`;
}
